import {getExplorerUrlForTransaction} from '@stripe-internal/crypto-utility';
import {SupportedNetwork} from 'src/types';

export const getExplorerUrl = ({
  network,
  livemode,
  blockchainTxId,
}: {
  network: SupportedNetwork;
  livemode: boolean;
  blockchainTxId: string;
}): string | null => {
  return getExplorerUrlForTransaction({
    network,
    mainnet: livemode,
    blockchainTxId,
  });
};
